import { Component, inject } from "@angular/core";
import {  IconComponent, ModalBekreftComponent } from "@husbanken/designsystem-angular-core";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "bko-kartlegging-header",
  imports: [IconComponent, ModalBekreftComponent],
  templateUrl: "./kartlegging-header.html",
  styleUrl: "./kartlegging-header.scss",
})
export class KartleggingHeader {
  private router = inject(Router);

  public visModal$ = new BehaviorSubject(false);

  public visModal(): void {
    this.visModal$.next(true);
  }

  public skjulModal(): void {
    this.visModal$.next(false);
  }

  public avslutt() {
    this.router.navigate(["kartlegging/avslutt"]);
  }
}
